import { render, staticRenderFns } from "./BlockRevisions.vue?vue&type=template&id=54133f20&"
import script from "./BlockRevisions.vue?vue&type=script&lang=js&"
export * from "./BlockRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports